// Same-origin paths served by a separate app behind the CDN (the React signup
// app at /signup), not by the Next.js marketing app that renders the link.
// next/link would SPA-intercept these and read the JSX href, bypassing the
// click-time AddUrlParamsToCrossSiteLinks forwarder — so CTAs pointing here
// must render a real anchor for a full browser navigation (see Button).
export const CROSS_APP_PATHS = ["/signup"];

export function isCrossAppHref(href: string): boolean {
  if (!href) return false;

  let pathname: string;
  if (/^https?:\/\//.test(href)) {
    try {
      pathname = new URL(href).pathname;
    } catch {
      return false;
    }
  } else if (href.startsWith("/") && !href.startsWith("//")) {
    // Root-relative path (e.g. "/signup") — same-origin, so next/link would
    // still SPA-intercept it. Strip any query/hash before matching.
    pathname = href.split(/[?#]/)[0];
  } else {
    return false;
  }

  return CROSS_APP_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}
